module.exports = __webpack_public_path__ + "static/media/icon-warning.41697f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/od-icons/icon-warning.svg
// module id = 1057
// module chunks = 0